import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import TextField from '@material-ui/core/TextField';

interface ITextFieldWrapperProps extends FieldRenderProps<any, any> {
    multiline: boolean;
    rows?: number;
}

const TextFieldWrapper: React.FunctionComponent<ITextFieldWrapperProps> = ({
    input: { name, onChange, value, ...restInput },
    meta,
    multiline,
    rows,
    ...rest
}) => {
    const showError = meta.touched && (meta.error || (meta.submitError && !meta.dirtySinceLastSubmit)) && !meta.submitting;

    return <TextField
        {...rest}
        error={showError}
        helperText={showError ? meta.error || meta.submitError : undefined}
        inputProps={restInput}
        name={name}
        onChange={onChange}
        value={value}
        autoComplete="off"
        multiline={multiline}
        rows={rows}
    />;
};

export default TextFieldWrapper;